import type { MaasGroupSpec } from '../../../../capabilities/maas-init/maasTypes';
import { MaasRunMode } from '../../../../capabilities/maas-init/maasTypes';
import { parseNodesField } from '../../../../capabilities/maas-node-groups/nodeFields';
import type { MaasNodeGroupsSnapshot, MaasNodesFormValues } from './types';

export function parseMaasNodeGroups(values: MaasNodesFormValues): MaasNodeGroupsSnapshot {
  return {
    runMode: values.runMode,
    masterNodes: parseNodesField(values.masterNodes),
    workerNodes: parseNodesField(values.workerNodes),
  };
}

export function shouldIncludeMasterGroup(runMode?: MaasRunMode): boolean {
  return runMode === MaasRunMode.PrimarySecondary;
}

export function resolveGroupReplicas(group?: MaasGroupSpec): number {
  const replicas = Number(group?.replicas);
  return Number.isFinite(replicas) && replicas > 0 ? replicas : 1;
}
